import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      &:focus,\n      &:hover {\n        background-color: ", ";\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  cursor: ", ";\n  display: block;\n  font-size: ", ";\n  line-height: 1;\n  padding: ", " ", ";\n  width: 100%;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import { color } from '@scp/ui-shared/theme/variables';
import { ClearedButton } from '@scp/ui-shared/theme/resets';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { baselineToRem, rem } from '@scp/ui-shared/theme/utils';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
var E2E_MENU_ITEM_SUFFIX = '-menu-item';
var KebabMenuItemButton = styled(ClearedButton)(_templateObject(), color.textPrimary, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, rem('14px'), baselineToRem(2), baselineToRem(4), function (_ref) {
  var disabled = _ref.disabled;
  return !disabled && css(_templateObject2(), color.backgroundSecondary);
});
var ButtonWithRipple = withRippleEffect(KebabMenuItemButton, undefined, false);
export function KebabMenuItem(_a) {
  var title = _a.title,
      disabled = _a.disabled,
      hidden = _a.hidden,
      buttonProps = __rest(_a, ["title", "disabled", "hidden"]);

  return React.createElement("li", null, React.createElement(ButtonWithRipple, Object.assign({
    disabled: disabled,
    "data-e2e": getE2eLabel(title, E2E_MENU_ITEM_SUFFIX)
  }, buttonProps), title));
}